import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Production from "@/pages/Production";
import MaterialsInward from "@/pages/MaterialsInward";
import Sales from "@/pages/Sales";
import Workers from "@/pages/Workers";
import Reports from "@/pages/Reports";
import Settings from "@/pages/Settings";
import PendingPayments from "@/pages/PendingPayments";
import ControlPanel from "@/pages/ControlPanel";
import StaffManagement from "@/pages/StaffManagement";
import Layout from "@/components/Layout";
import "@/App.css";

function PrivateRoute({ children }) {
  const token = localStorage.getItem('token');
  return token ? children : <Navigate to="/login" />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={
            <PrivateRoute>
              <Layout />
            </PrivateRoute>
          }>
            <Route index element={<Dashboard />} />
            <Route path="production" element={<Production />} />
            <Route path="materials-inward" element={<MaterialsInward />} />
            <Route path="sales" element={<Sales />} />
            <Route path="workers" element={<Workers />} />
            <Route path="reports" element={<Reports />} />
            <Route path="settings" element={<Settings />} />
            <Route path="pending-payments" element={<PendingPayments />} />
            <Route path="control-panel" element={<ControlPanel />} />
            <Route path="staff-management" element={<StaffManagement />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;